import { Mail } from "lucide-react";

export default function ReturnPolicyPage() {
    return (
        <div className="min-h-[70vh]" data-testid="return-policy-page">
            <div className="bg-card border-b border-border">
                <div className="container mx-auto px-6 lg:px-12 py-12 lg:py-20">
                    <p className="font-mono text-xs uppercase tracking-widest text-primary mb-4">Policy</p>
                    <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black text-foreground tracking-tight mb-4">
                        Returns & Refunds
                    </h1>
                </div>
            </div>

            <div className="container mx-auto px-6 lg:px-12 py-12 lg:py-20 max-w-3xl">
                <div className="space-y-8 text-muted-foreground text-sm leading-relaxed">
                    <p>
                        Due to the highly specialized, high-ticket industrial nature of dry ice blasting equipment, <span className="text-foreground font-bold">all machinery sales are final</span>. Standard original manufacturer warranties apply to all units.
                    </p>

                    <p>
                        Individual accessories and nozzles are eligible for return within <span className="text-foreground font-bold">14 days</span> of receipt if they remain unused and in original factory packaging.
                    </p>

                    <p>
                        <span className="text-foreground font-bold">Credit card processing surcharges are strictly non-refundable.</span>
                    </p>

                    <div>
                        <h2 className="font-heading text-lg font-bold text-foreground mb-3">We do not accept returns or exchanges for:</h2>
                        <ul className="list-disc list-inside space-y-1">
                            <li>Used equipment</li>
                            <li>Special-order machines</li>
                            <li>Imported equipment</li>
                            <li>Custom-configured systems</li>
                            <li>Air compressors and accessories after shipment</li>
                        </ul>
                    </div>

                    <p>
                        If a product arrives damaged during transport or has a verified manufacturing defect, customers must notify us within <span className="text-foreground font-bold">48 hours</span> of delivery.
                    </p>

                    <p>
                        Dry Ice Bulls will work with the manufacturer and shipping carrier to resolve eligible damage or warranty claims.
                    </p>

                    <div>
                        <h2 className="font-heading text-lg font-bold text-foreground mb-3">Customers are responsible for:</h2>
                        <ul className="list-disc list-inside space-y-1">
                            <li>Inspecting shipments upon arrival</li>
                            <li>Reporting visible freight damage immediately</li>
                            <li>Following all operating and safety instructions</li>
                        </ul>
                    </div>

                    <p>Warranty coverage, if applicable, is provided by the original manufacturer.</p>

                    <div className="border-t border-border pt-6">
                        <p className="text-foreground font-bold mb-2">For assistance, please contact:</p>
                        <a href="mailto:info@dryicebulls.com" className="flex items-center gap-2 text-primary hover:text-primary/80 transition-colors">
                            <Mail className="h-4 w-4" /> info@dryicebulls.com
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}
